import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components';
import {getRoutes} from '../../utils';
import {withTheme} from './HOC/withTheme';
import MenuItem from './MenuItem';
import {withLoadedUser} from '../../login/containers/AuthBase';

const Nav = styled.nav`
  width: 250px;
`;

const MenuDiv = styled.div`
  &&& {
     background: ${({color}) => color};
  }
`;



class SideMenu extends PureComponent {
  render() {
    const {location, toggleMenu, theme,currentUser} = this.props;
    const routes = getRoutes(currentUser.role);
    const {pathname} = location;
    const path = pathname;
    return (
      <MenuDiv color={theme.sidebar.background} className="sidebar">
        <Nav>
          <ul className="nav">
            {routes.map((route, index) => {
              const active = path === route.to;

              return (
                <li className="nav-item" key={index}>
                  <MenuItem active={active} route={route}/>
                </li>
              );
            })}
            <li className="navbar-footer">
              <button className="navbar_footer_btn" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faChevronLeft} color={'grey'} />
              </button>
            </li>
          </ul>
        </Nav>
      </MenuDiv>
    );
  }
}

SideMenu.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  toggleMenu: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    sidebar: PropTypes.shape({
      background: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  currentUser: PropTypes.shape({
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  withRouter,
  withTheme,
  withLoadedUser,
)(SideMenu);
